<template>
  <div class="homebox clearfix">
    <!-- 首页的头部 -->
    <Head page="通知公告" />
    <div class="owin-height">
      <div class="notice-top">
        <div class="page-title">
          <span class="text">通知公告</span>
        </div>
        <div class="notice-total" v-show="showSearchResult">
          共搜索到 <span>{{ pageInfo.rows }}</span> 条相关公告
        </div>
        <el-input
          v-model="newsName"
          size="medium"
          class="search-input"
          @keyup.enter="handleSearch()"
          placeholder="搜索通知公告"
        >
          <template #suffix>
            <i
              class="iconfont iconsousuo search-icon"
              @click="handleSearch()"
            ></i>
          </template>
        </el-input>
      </div>
      <div class="notice-wrapper">
        <el-affix v-if="newsTypeList && newsTypeList.length" :offset="0">
          <ul class="nav-list">
            <li
              @click="handleSearch()"
              class="nav"
              :class="!pageInfo.newsTypeId && 'active'"
            >
              首页
            </li>
            <li
              @click="handleSearch(id)"
              class="nav"
              :class="pageInfo.newsTypeId === id && 'active'"
              v-for="{ id, name } in newsTypeList"
              :key="id"
            >
              {{ name }}
            </li>
          </ul>
        </el-affix>
        <div
          :style="{
            'flex-grow': newsTypeList && newsTypeList.length ? 0 : 1,
          }"
          class="notice-list-wrapper"
        >
          <div v-if="newsList.length" class="notice-list">
            <div
              class="notice-item"
              v-for="item in newsList"
              :key="item.id"
              @click="showNewsDetail(item.id)"
            >
              <div
                class="notice-title text-overflow"
                :title="item.name"
                v-html="kewordFilter(item.name)"
              ></div>
              <div class="notice-count">
                <span
                  >{{ dayjs(item.publish_time).format("YYYY-MM-DD") }} |
                </span>
                浏览{{ item.view_num || 0 }}次
              </div>
            </div>
          </div>
          <EmptyIcon v-else type="message" text="暂无公告" />

          <el-pagination
            class="news-pagination"
            background
            layout="prev, pager, next"
            prev-text="上一页"
            next-text="下一页"
            @current-change="pageIndexChange"
            :current-page="pageInfo.pageIndex"
            :total="pageInfo.rows"
            :page-size="pageInfo.pageLimit"
            v-if="pageInfo.rows && pageInfo.rows > pageInfo.pageLimit"
          >
          </el-pagination>
        </div>
      </div>
    </div>
    <Footer />
  </div>
</template>

<script>
import Head from "./../components/Head";
import Footer from "./../components/Footer";
import EmptyIcon from "components/EmptyIcon";

import dayjs from "dayjs";
export default {
  created() {
    this.getNewsTypeList();
    this.getNewsList();
  },
  components: {
    Head,
    Footer,
    EmptyIcon
  },
  data() {
    return {
      newsList: [],
      newsTypeList: [],
      pageInfo: {
        pageIndex: 1,
        rows: 0,
        pageLimit: 10,
        newsTypeId: "",
      },
      newsName: "",
      showSearchResult: false,
    };
  },
  methods: {
    async getNewsTypeList() {
      const newsTypeList = await this.$http.nuc.getNewsTypeList();
      this.newsTypeList = newsTypeList;
    },
    async getNewsList() {
      const params = {
        name: this.newsName || undefined,
        "_where.like": this.newsName ? "name" : undefined,
        "_pageable.page": this.pageInfo.pageIndex - 1,
        newsTypeId: this.pageInfo.newsTypeId,
        "_pageable.size": this.pageInfo.pageLimit,
      };
      const res = await this.$http.nuc.getNewsList(params);
      this.newsList = res.content;
      this.pageInfo.rows = +res.totalElements;
    },
    // 切换分页
    pageIndexChange(current) {
      this.pageInfo.pageIndex = current;
      this.getNewsList();
    },
    // 获取新闻详情
    async getNewsDetail() {
      const res = await this.$http.nuc.getNewsDetail({
        id: 1,
      });
    },
    // 搜索
    handleSearch(newsTypeId = "") {
      this.pageInfo.pageIndex = 1;
      this.pageInfo.newsTypeId = newsTypeId;
      this.getNewsList();
      this.showSearchResult = true;
    },
    // 关键字高亮
    kewordFilter(value) {
      if (!value) return "";
      if (!this.newsName) return value;
      let reg = new RegExp(this.newsName, "g");
      return value.replace(
        reg,
        `<span class="theme-color">${this.newsName}</span>`
      );
    },
    // 格式化新闻内容
    formateNews(data) {
      let result = this.$utils.getContentText(data);
      return this.kewordFilter(result);
    },
    // 点击卡片进去详情页
    showNewsDetail(id) {
      window.location.href = `/noticeDetail.html?id=${id}`;
    },
    dayjs,
  },
};
</script>

<style lang="scss" scoped>
@import "assets/index";
.homebox {
  min-height: 100%;
  display: flex;
  flex-direction: column;
  .header {
    height: 140px;
    background-size: 100%;
  }
  .owin-height {
    width: 1200px;
    margin: 26px auto 0;
    flex: 1;
    padding-top: 0;
    padding-bottom: 0;
    display: flex;
    flex-direction: column;
    .nav-list {
      width: 200px;
      border: 1px solid #dddddd;
      background-color: #fff;
      list-style: none;
      .nav {
        font-size: 16px;
        color: #2a2a2a;
        line-height: 22px;
        text-align: center;
        padding: 17px 0;
        cursor: pointer;
        & + .nav {
          border-top: 1px solid #dddddd;
        }
        &:hover {
          color: $--color-primary;
        }
        &.active {
          color: #fff;
          background: $--color-primary;
        }
      }
    }
    .notice-top {
      display: flex;
      justify-content: space-between;
      align-items: center;
      position: relative;
      .notice-total {
        position: absolute;
        bottom: 8px;
        right: 210px;
        margin-right: 5px;
        font-size: 12px;
        color: #333;
        span {
          color: $--color-primary;
        }
      }
      .search-input {
        width: 200px;
        :deep(.el-input__inner) {
          // border: 1px solid transparent;
          background: #fff;
          font-size: 12px;
          &:focus {
            border: 1px solid $--color-primary;
          }
        }
        :deep(.el-input__suffix) {
          right: 10px;
        }
        .search-icon {
          color: $--color-primary;
          font-size: 14px;
          cursor: pointer;
        }
      }
    }

    .notice-wrapper {
      padding-top: 20px;
      // border-top: 1px solid #dddddd;
      display: flex;
      flex: 1;
      .notice-list-wrapper {
        background: #fff;
        padding: 24px;
        margin-left: 20px;
        margin-bottom: 50px;
        flex: 0 0 980px;
        display: flex;
        flex-direction: column;
        .notice-list {
          flex: 1;
        }
      }
      .notice-item {
        display: flex;
        align-items: center;
        justify-content: space-between;
        position: relative;
        color: #757d8c;
        font-size: 12px;
        cursor: pointer;
        list-style: none;
        &:hover {
          .notice-title {
            color: $--color-primary;
          }
        }
        .notice-title {
          width: 0;
          flex: 1;
          font-size: 16px;
          color: #333;
          line-height: 22px;
          margin: 0 60px 0 15px;
          &::before {
            content: "· ";
          }
        }
        .notice-count {
          font-size: 12px;
          color: #999;
          line-height: 16px;
        }
        & + .notice-item {
          margin-top: 24px;
        }
      }
    }

    .empty-box {
      margin: 0 auto;
      padding-top: 100px;
      height: 500px;
      text-align: center;
      img {
        width: 150px;
        margin-bottom: 10px;
      }
    }
  }
}
.news-pagination {
  margin-top: 34px;
  text-align: center;
  line-height: 30px;
  &.is-background {
    :deep(.btn-prev),
    :deep(.btn-next) {
      padding-top: 3px;
      background-color: transparent;
    }
    :deep(.el-pager li) {
      width: 30px;
      height: 30px;
      border-radius: 50%;
      background-color: transparent;
      text-align: center;
      line-height: 30px;
    }
  }
}
</style>